<template>
  <el-dialog
    :visible.sync="invalidVisible"
    class="preview_box"
    :modal="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    title="作废申请"
    width="600px"
    :center="true">
    <el-form
        :model="form"
        label-width="100px"
        class="demo-form-inline edit_from"
        ref="editForm"
        :rules="rules">
        <el-form-item label="作废原因:" prop="reason">
          <el-select v-model="form.reason">
            <el-option
              v-for="item in reason"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入作废描述"></el-input>
        </el-form-item>
        <el-form-item class="section__footer">
          <el-button type="zebra-primary" @click="save">提交</el-button>
          <el-button class="btn__reset" type="default" @click="defalut">取消</el-button>
        </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: 'frost',
  props: {
    invalidVisible: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: Number,
      defalut: 0
    },
    invalidType: {
      type: String,
      default: 'detail'
    }
  },
  data () {
    return {
      rules: {
        remark: [
          { required: true, message: '请输入作废描述', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请选择作废原因', trigger: 'change' }
        ]
      },
      reason: [
        {
          label: '执行作废',
          value: '执行作废'
        },
        {
          label: '研究作废',
          value: '研究作废'
        },
        {
          label: '客户原因',
          value: '客户原因'
        },
        {
          label: '经销商原因',
          value: '经销商原因'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      form: {
        reason: '',
        remark: ''
      }
    }
  },
  methods: {
    save () {
      let that = this
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.saveDealer()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async saveDealer () {
      console.log(this.invalidType)
      let { data } = await this.axios.post(this.invalidType === 'online' ? '/home/auditor/task/recheckCancelApply' : 'home/rechecksupervisor/task/recheckCancelApply', { ...this.form, task_id: this.taskId })
      let { success, results } = data
      if (success) {
        this.defalut()
        this.$router.go(-1)
      } else {
        this.$message(results.msg)
      }
    },
    defalut () {
      this.$emit('defalut')
      this.form = {
        reason: '',
        desc: ''
      }
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.form{
  /deep/.el-select,
  .el-input {
    width: 99px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
}
.tab_wrap{
    width: 68%;
    margin: 0 auto;
}
.edit_from {
    &--tips{
      font-size: 10px;
      margin-bottom: 15px;
      text-align: center;
    }
    .el-form-item{
      margin-bottom: 20px;
    }
}
.preview_box{
  /deep/.el-dialog__headerbtn{
    display: none
  }
}
</style>
